<div class="col-12">
  <div class="col-4 align-left">
  </div>
  <div class="col-4 align-center">
  </div>
  <div class="col-4 align-right">
    <button type="button" [icon]="'fa fa-check'" class="p-button-warning"
            [iconPos]="'right'" [disabled]="!nextEnabled()"
            [label]="'COMMON.VALIDATE' | translate" pButton (click)="closeComponent()"></button>
  </div>
</div>

<div class="col-12">
  <p-fieldset [legend]="'UPLOAD_COMPONENT.LRE_RECIPIENT_LABEL' | translate">
    <ng-template pTemplate="content">
      <div class="grid gap-2">
        <div class="col-12">
          <div class="col-3 title-input">
            {{'COMMON.SIGNER.TITLE' | translate}}
          </div>
          <div class="col-9">
            <p-dropdown [options]="signerQualityItems$ | async"
                        (ngModelChange)="onTypeActorChange($event)"
                        [(ngModel)]="recipient.signerQuality"></p-dropdown>
          </div>
        </div>
        <div class="col-12 content-margin-space" *ngIf="recipient.signerQuality === SignerQualityEnum.INDIVIDUAL">
          <!-- recipient.title -->
          <div class="col-2">
            <p-dropdown [filter]="false" [options]="titleItems$ | async"
                        [(ngModel)]="recipient.title"></p-dropdown>
          </div>
          <!-- recipient.firstName -->
          <div class="col-5">
            <span class="p-float-label">
              <input id="recipientFirstName"
                     [ngClass]="{'valid': recipient.firstName , 'not-valid': !recipient.firstName}"
                     [(ngModel)]="recipient.firstName" type="text" size="30" pInputText>
              <label for="recipientFirstName">{{'UPLOAD_COMPONENT.LRE_S_FIRSTNAME_LABEL' | translate}}</label>
            </span>
          </div>
          <!-- recipient.lastName -->
          <div class="col-5">
            <span class="p-float-label">
              <input id="recipientLastName"
                     [ngClass]="{'valid': recipient.lastName , 'not-valid': !recipient.lastName}"
                     [(ngModel)]="recipient.lastName" type="text" size="30" pInputText>
              <label for="recipientLastName">{{'UPLOAD_COMPONENT.LRE_S_LASTNAME_LABEL' | translate}}</label>
            </span>
          </div>
        </div>
        <div class="col-12" *ngIf="recipient.signerQuality === SignerQualityEnum.PROFESSIONAL">
          <label class="col-3" for="recipientcompany">{{'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate}}</label>
          <input class="col-9" id="recipientcompany" pInputTextarea
                 [ngClass]="{'valid': recipient.company , 'not-valid': !recipient.company}"
                 [(ngModel)]="recipient.company" type="text" size="30">
        </div>
        <div class="col-12">
          <!-- recipient.mailAddress -->
          <label class="col-3" for="recipientmailAddress">{{'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate}}</label>
          <input class="col-9" id="recipientmailAddress"
                 [ngClass]="{'valid': isValidMail(recipient.mailAddress), 'not-valid': !isValidMail(recipient.mailAddress)}"
                 [(ngModel)]="recipient.mailAddress" type="text" size="30" pInputText>
        </div>
        <div class="col-12" [ngClass]= "{'content-margin-space': recipient.authenticationType === AuthTypeEnum.SMS}">
          <!-- recipient.authenticationType -->
          <div class="col-3">
            <p-dropdown [filter]="false" [options]="authTypeItems$ | async"
                        (ngModelChange)="onAuthenticationChange($event)"
                        [(ngModel)]="recipient.authenticationType"></p-dropdown>
          </div>
          <!-- recipient.phoneNumber -->
          <div class="col-9" *ngIf="recipient.authenticationType === AuthTypeEnum.SMS">
            <span class="p-float-label">
              <input id="recipientphoneNumber"
                     [ngClass]="{'valid': recipient.phoneNumber , 'not-valid': !recipient.phoneNumber}"
                     [(ngModel)]="recipient.phoneNumber " type="text" size="30" pInputText>
              <label for="recipientphoneNumber">{{'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate}}</label>
            </span>
          </div>
          <div class="col-6" *ngIf="recipient.authenticationType !== AuthTypeEnum.SMS">&nbsp;</div>
        </div>

        <div class="col-12">
          <div class="col-3">
            <label for="senderAddress">{{'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' | translate}}</label>
          </div>
          <div class="col-7">
            <textarea id="senderAddress" rows="5" [readOnly]="true" class="w-full"
                  [ngClass]="{'not-valid': !isValidAddress(recipient.address), 'valid': isValidAddress(recipient.address) }"
                  [(ngModel)]="recipient.address" pInputTextarea [autoResize]="false"></textarea>
          </div>
          <div class="col-2">
            <button pButton type="button" [icon]="'fa fa-pencil'" class="p-button-info"
                    [label]="'COMMON.EDIT' | translate"
                    (click)="showSenderAddress()"></button>
            <p-dialog *ngIf="openSenderAddress" [(visible)]="openSenderAddress" [styleClass]="'adressModal'"
                      [appendTo]="'body'"
                      [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
                      [draggable]="false"
                      [closable]="true"
                      [resizable]="false"
                      [modal]="true" [closeOnEscape]="false">
              <app-address (finalAddress)="handleRecipientAddress($event)"
                           (visible)="handleSenderAddressClose($event)"
                           [oldAddress]="currentRecipientAddress"></app-address>
            </p-dialog>
          </div>
        </div>

      </div>
    </ng-template>
  </p-fieldset>
</div>
